import {
  FilterInfoOperator,
  FormattingRuleOperator,
  type FormattingOperator,
} from '@ardoq/api-types';
import { AttributeComparators } from '../../collections/attributeComparators';

const FORMATTING_RULE_OPERATORS: ReadonlySet<string> = new Set(
  Object.values(FormattingRuleOperator)
);

/**
 * The comparator an attribute filter on `name` is stored with: a colour range
 * is stored as `equals`, and a comparator the field does not support is
 * replaced by the field's first valid one.
 */
export const coerceComparator = (
  name: string,
  comparator: FormattingOperator | undefined
): FormattingOperator | undefined => {
  if (comparator === FormattingRuleOperator.COLOR_RANGE) {
    return FilterInfoOperator.EQUALS;
  }
  const validComparators = AttributeComparators.getAvailableComparators(name);
  const isKept =
    validComparators.some(valid => valid?.id === comparator) ||
    (comparator !== undefined && FORMATTING_RULE_OPERATORS.has(comparator));
  return isKept ? comparator : validComparators[0]?.id;
};
